import constants from '~/config/constants';

/**
 * @param {import("@nuxt/types").Context} context
 * @return {Promise<Record<string, any>>}
 */
export default async function getApiDataByContext({ $axios, error, isDev, redirect, route, res }) {
    /** @type {import('axios').AxiosResponse} */
    let response;

    /** @type {Record<string, any>} */
    let data;

    if (process.server) {
        try {
            data = await res.getApiData();
        } catch (e) {
            /** @type {import('@tidal/user-models').ClientApiError | import("@nuxt/types").NuxtError} */
            const apiError = e;

            error(apiError);
            return {};
        }

        if (data?.redirectUrl) {
            if (res.headersSent) {
                console.error('Redirecting after headers already set', res.getHeaders(), res.statusCode);
                return {};
            }
            // if 'data.redirectUrl' is a valid absolute path then the base is ignored
            const url = new URL(data.redirectUrl, constants.API_URL_BROWSER);
            redirect(url.href);
            return {};
        } else if (data?.message === 'Method not found.') {
            // Microservice Base can return such message if there is no API route matching the Nuxt route.
            redirect(constants.API_URL_BROWSER);
            return {};
        }

        return data;
    }

    try {
        response = await $axios.get(`/api${route.fullPath}`);
    } catch (e) {
        /** @type {import('axios').AxiosError<import('@tidal/user-models').ClientApiError>} */
        const apiError = e;

        if (apiError.response && apiError.response.data) {
            error({
                ...apiError.response.data,
                // @ts-ignore
                isDev,
            });
        } else {
            error(apiError);
        }
        return {};
    }

    if (response && response.data && response.data.redirectUrl) {
        const url = new URL(response.data.redirectUrl, constants.API_URL_BROWSER);
        redirect(url.href);
        return {};
    }

    return response.data;
}
